webpackJsonp([3785283273776],{

/***/ 564:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","author":{"name":"Nick Long","twitter":"monquixote"}}},"markdownRemark":{"id":"/opt/build/repo/src/pages/articles/2007-12-02---the-daddy-advent-calender/2007-12-02-the-daddy-advent-calender.md absPath of file >>> MarkdownRemark","html":"<p><a href=\"http://forum.thedaddy.org/view_thread.html?ref_id=29831\">I’m running an online advent calender over on thedaddy.org</a> </p>\n<p>I was thinking about cross posting it onto my blog but I’m going to find it hard enough to keep the thread updated let alone keep this place in step as well.</p>","fields":{"tagSlugs":null},"frontmatter":{"title":"The Daddy Advent Calender","tags":null,"date":"2007-12-02T02:35:00.000Z","description":null}}},"pathContext":{"slug":"/the-daddy-advent-calender/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---the-daddy-advent-calender-6b6324962fc70859603d.js